import i18n from 'i18next'

// Kept out of i18n.ts, which imports every catalogue: a component that only reads the language should not depend on
// the texts, or every text change gives it a new file name

// You actually can't look up languages from i18n (wth?)
export const supportedLanguages = [
  // Language names are in the local language, so no matter the selected language you can identify "your" language
  // i.e. they should _not_ be translated
  { code: 'nb', name: 'Norsk' },
  { code: 'en', name: 'English' },
  { code: 'fi', name: 'Suomi' },
  { code: 'dk', name: 'Dansk' },
  { code: 'sv', name: 'Svenska' },
  { code: 'fr', name: 'Français' }
]

export const getCurrentLanguageCode = () =>
  supportedLanguages.find((lng) => lng.code === (i18n.resolvedLanguage ?? i18n.language))?.code || 'en'
